export { default as Campo } from './Campo';
export { default as RutPasaporte, Props as RutPasaporteProps } from './RutPasaporte';
export { default as Info } from './Info';
export { default as InformacionMatricula } from './InformacionMatricula';
export { default as Asignatura } from './Asignatura';
export { default as Direccion } from './Direccion';
export { default as InformacionPersonal } from './InformacionPersonal';
export { default as InformacionPersonalApoderado } from './InformacionPersonalApoderado';
export { default as InformacionPersonalAlumno } from './InformacionPersonalAlumno';
export { default as InformacionDeContacto } from './InformacionDeContacto';
export * from './CursosInscritos';



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/InformacionGeneral/componentes/index.ts